// src/features/production/shortageHold/store/shortageHoldStore.ts
// ADR-105. Zustand store for UI filter state (similar to downtime store).

import { create } from "zustand";

interface ShortageHoldStoreState {
  selectedWorkOrderId: string | null;
  selectedStatus: string | null;
  setSelectedWorkOrderId: (id: string | null) => void;
  setSelectedStatus: (status: string | null) => void;
}

export const useShortageHoldStore = create<ShortageHoldStoreState>((set) => ({
  selectedWorkOrderId: null,
  selectedStatus: null,
  setSelectedWorkOrderId: (selectedWorkOrderId) => set({ selectedWorkOrderId }),
  setSelectedStatus: (selectedStatus) => set({ selectedStatus }),
}));
